module.exports = __webpack_public_path__ + "img/usage-7.a2f8179a.png";